import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Zendesk, { ZendeskAPI } from './utils/ZendeskConfig';
import Home from './pages/Home';
import './App.css';
import ProfessionalsExplorer from './pages/ProfessionalsExplorer';
import ProfessionalPage from './pages/ProfessionalPage';

const ZENDESK_KEY = process.env.REACT_APP_ZENDESK_ID;

function App() {
  const handleLoaded = () => {
    ZendeskAPI('messenger', 'close');
  };

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profissionais" element={<ProfessionalsExplorer/>} />
          <Route path="/profissionais/buscar" element={<ProfessionalPage />} />
        </Routes>
      </BrowserRouter>
      <Zendesk defer zendeskKey={ZENDESK_KEY} onLoaded={handleLoaded} />
    </>
  );
}

export default App;